import StringRen from "csi/heading/String";
import sessionConstants from "csi/sessionConstants";
import { DECIMAL_INTERNAL } from "csi/utility/numberUtility";
import { formatStringValue } from "csi/utility/stringUtility";
import declare from "dojo/_base/declare";

const ExpressionRenderer = declare(StringRen, {
	/**
     * @override
     * Format expression fields to show locale decimal separator
     */
	formatValue(value: any, fmt: string): string {
		return formatStringValue(value.replaceAll(DECIMAL_INTERNAL, sessionConstants.decimalSeparator));
	},
});

export = ExpressionRenderer;